import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import { ReactComponent as Done } from '../../../assets/icons/Logout.svg';
import actions from '../../../actions';
import DialogBox from '../../components/DialogBox';
import * as Constant from '../../../constants/actionTypes';
import { firstLowerLetter, labelName } from '../../UtilsWeb';
import styles from './styles';

class MyHealthSummary extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  state = {
    isOpen: false,
  };

  componentDidMount = () => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener(Constant.POP_STATE, () => {
      // eslint-disable-next-line react/prop-types
      const { actions: actionCall } = this.props;
      actionCall.reset();
    });
  };

  componentWillUnmount = () => {
    window.removeEventListener(Constant.POP_STATE, {});
  };

  toggle = confirm => {
    const { isOpen } = this.state;
    // eslint-disable-next-line react/prop-types
    const { history, actions: actionCall } = this.props;

    this.setState({ isOpen: !isOpen });

    if (confirm === Constant.TRUE) {
      actionCall.reset();
      history.push(`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_LOGIN_LINK)}`);
    }
  };

  goBack = () => {
    this.setState({
      isOpen: true,
    });
  };

  openBase64PDF = base64PDF => {
    const blobData = Uint8Array.from(atob(base64PDF), c => c.charCodeAt(0));
    const blob = new Blob([blobData], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    return url;
  };

  render() {
    const { isOpen } = this.state;
    const { locale, classes, location } = this.props;
    const { state } = { ...location };
    const { data } = { ...state };
    const { data: PDF } = { ...data };
    const { file } = { ...PDF };
    const Height = window.innerHeight - 80;
    return (
      <div>
        <Paper className={classes.paperStyle}>
          {/* <h3 className="pageHeader">{labelName(Constant.LABEL_HEALTH_SUMMARY)}</h3> */}
          <div style={{ width: 'calc(100vw-20px)', background: '#ccc', height: Height }}>
            <iframe
              title={labelName(Constant.LABEL_POPUP_HEALTH_SUMMARY_HEADER1)}
              src={this.openBase64PDF(file)}
              width="100%"
              height="100%"
            />
          </div>
          <Fab
            color="primary"
            aria-label="Add"
            onClick={this.goBack}
            className={classes.backBtnPosition}
          >
            <Done className={classes.backIconStyle} />
          </Fab>
          {isOpen && (
            <DialogBox
              open={isOpen}
              locale={locale}
              toggle={this.toggle}
              dialogTitle={labelName(Constant.LABEL_POPUP_HEALTH_SUMMARY_HEADER1)}
              dialogContentText={labelName(Constant.LABEL_POPUP_HEALTH_SUMMARY_HEADER2)}
            />
          )}
        </Paper>
      </div>
    );
  }
}

MyHealthSummary.propTypes = {
  locale: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  locale: state.locale.locale,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});
const x = injectIntl(MyHealthSummary);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(x)); // HOC(x)
